import React, { Component } from 'react'
import { convertBreakCharsToLineBreaks } from 'utils/dom'
import Row from 'components/common/row'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import TextField from 'components/ui/text-field'
import ContactCard from '../../contact-card'
type Props = {
  note: Record<string, any>
  onDelete: (...args: Array<any>) => any
  onUpdate: (...args: Array<any>) => any
  onEdit?: (...args: Array<any>) => any
  onCancelEdit?: (...args: Array<any>) => any
}
type State = {
  editMode: boolean
  deleting: boolean
  updating: boolean
}
export default class Note extends Component<Props, State> {
  state: State = {
    editMode: false,
    deleting: false,
    updating: false,
  }
  _noteText: any
  _onEditSwitch: () => void = () => {
    if (this.state.editMode && this.props.onCancelEdit) {
      this.props.onCancelEdit()
    } else if (!this.state.editMode && this.props.onEdit) {
      this.props.onEdit()
    }

    this.setState({
      editMode: !this.state.editMode,
    })
  }
  _onDeleteNote: () => void = () => {
    this.setState({
      deleting: true,
    })
    // TODO: Show delete confirmation with possible undo
    this.props.onDelete().catch(() =>
      this.setState({
        deleting: false,
      }),
    )
  }
  _onUpdateNote: () => void = () => {
    const { value } = this._noteText
    if (!value) return
    this.setState({
      updating: true,
    })
    this.props
      .onUpdate(value)
      .then(() => {
        this.setState({
          editMode: false,
          updating: false,
        })
      })
      .catch(() =>
        this.setState({
          updating: false,
        }),
      )
  }

  render(): React.ReactNode {
    const { note } = this.props
    const { editMode, deleting, updating } = this.state
    return editMode ? (
      <ContactCard>
        <Row columnsSize={[12]} marginBottom>
          <div>
            <TextField
              label="Edit note"
              defaultValue={note.content}
              inputRef={r => {
                this._noteText = r
              }}
              multiline
            />
          </div>
        </Row>
        <ButtonContainer>
          <Button
            appearance="primary"
            caption="Save note"
            onClick={this._onUpdateNote}
            progressIndicator={updating}
            progressCaption="Saving note"
          />
          <Button
            appearance="danger"
            caption="Delete"
            onClick={this._onDeleteNote}
            progressIndicator={deleting}
            progressCaption="Deleting note"
          />
        </ButtonContainer>
      </ContactCard>
    ) : (
      <ContactCard
        action={{
          content: 'Edit',
          onClick: this._onEditSwitch,
        }}
      >
        {convertBreakCharsToLineBreaks(note.content)}
      </ContactCard>
    )
  }
}
